export const bulkMessagesCountLimit = process.env.VUE_APP_BULK_MESSAGES_UI_LIMIT
export const lookupCountLimit = process.env.VUE_APP_LOOKUP_UI_LIMIT
export const balanceNotificationEmailCount = process.env.VUE_APP_MAX_BALANCE_NOTIFICATION_COUNT
